import { scopedLogger, logInfo, logError } from '@lib/utils/logUtils'
import { useAppStore } from '@stores/app.store'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useGtm } from './useGtm'
import { orderedAndUniqueProductList } from '@lib/utils/productUtils'
import { purchaseService } from '@lib/services/backend/purchase/purchase.service'

const log = scopedLogger('@composables/useCartActions.vue')

export const useCartActions = () => {
  const store = useAppStore()
  const router = useRouter()
  const { trackGoCart, trackPackLogoutAndExit } = useGtm()

  const cartUnits = computed(() => store.cartUnits)
  const accessibleMode = computed(() => store.accessibility)

  const viewCrossSelling = async () => {
    await router.push({ name: 'crossSelling' })
  }

  const viewCart = async () => {
    await router.push({ name: 'cart' })
  }

  const navigateSeeOrder = async () => {
    trackGoCart()
    if (store.lastProductList === orderedAndUniqueProductList(store.cart)) await viewCart()
    else await viewCrossSelling()
  }

  const sendReset = async (gtmLogoutType: string) => {
    store.resetADK = true
    logInfo(log, 'Send RESET ADK STATE, going to splash')
    trackPackLogoutAndExit(gtmLogoutType)
    // go to splash
    await router.push({ name: 'splash' })
  }

  const changeAccesibleMode = () => {
    store.setAccessibility(!store.accessibility)
  }

  const resetCartToEmpty = async () => {
    if (!store.cart) return false

    try {
      store.cart = await purchaseService.fetchCleanupPurchaseSession(store.cart.sessionId)
      return true
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      logError(log, 'Error resetting cart to empty ' + (error?.message || error))
      return false
    }
  }

  return {
    cartUnits,
    accessibleMode,
    navigateSeeOrder,
    sendReset,
    changeAccesibleMode,
    resetCartToEmpty
  }
}
